/** チャートの見える月数の範囲 */
export const VISIBLE_MONTHS_OPTIONS = Object.freeze([6, 12, 24]);

/** チャートエリアにおける左側の余白 */
export const CHART_AREA_MARGIN_LEFT = 80;
/** チャートエリアにおける棒グラフの幅 */
export const BAR_WIDTH = 14;
/** チャートのプライマリカラー */
export const CHART_PRIMARY_COLOR = "#94A3B8";
